import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { useAppDispatch, useAppSelector } from '../../useStore';
import swal from 'sweetalert';
import { reset, shareApplication } from '../../features/Applicant/applicantSlice';
import { getallReguser } from '../../features/Registration/registrationSlice';
import { Spinners } from '../TableOptions';
import ModalHeader from '../ModalHeader';



const ShareModal = ({ title, applicationId }) => {
	const dispatch = useAppDispatch();
	const { shareApplicationisError, shareApplicationmessage, shareApplicationisLoading, shareApplicationisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)
	const { dataAll } = useAppSelector((state: { registration: any; }) => state.registration)
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);


	useEffect(() => {
		if (show) {
			dispatch(getallReguser());
		}
	}, [dispatch]);

	const [inputs, setInputs] = useState({
		recruiterID: "",
		applicationId: "",
	})





	useEffect(() => {
		if (shareApplicationisError) {
			swal({
				title: "error",
				text: shareApplicationmessage,
				// @ts-ignore
				icon: "error"
			})
		} else if (shareApplicationisSuccess) {
			swal({
				title: "success",
				text: "Application Shared!",
				// @ts-ignore
				icon: "success"
			})
			setShow(false)
			setInputs(
				{
					recruiterID: "",
					applicationId: "",
				}
			)
		}
		dispatch(reset())
	}, [shareApplicationisError, shareApplicationisSuccess, shareApplicationmessage, dispatch])



	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				applicationId: applicationId
			});
		});
	}, [applicationId, inputs.applicationId, setInputs]);


	const handleApplicationId = () => {
		// @ts-ignore  
		dispatch(shareApplication(inputs));
	}




	return (
		<div>
			<div onClick={handleShow} className="more-button">
				{title}
			</div>

			<Modal show={show} onHide={handleClose} centered>
				<ModalHeader setShow={setShow} headerTitle={"Share"} />
				<Modal.Body>

					<form>
						<div className='reviewer-name'>
							<h4>Share with</h4>

							<select className="round"
								value={inputs.recruiterID}
								onChange={(e) => handleOnChange("recruiterID", e.target.value)}>
								<option>Select Recruiter</option>

								{dataAll?.data?.map((item: any) => (
									<option key={item?.id} value={item?.id} >
										{item?.firstName + " " + item?.LastName}
									</option>
								))}
							</select>
						</div>
					</form>
				</Modal.Body>


				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Cancel
					</Button>
					<Button id="primary" onClick={handleApplicationId}>
						{shareApplicationisLoading ? <Spinners size={"sm"} /> : 'Share'}
					</Button>
				</Modal.Footer>
			</Modal>

		</div>
	)
}

export default ShareModal